export var AnswerReplyType;
(function (AnswerReplyType) {
    AnswerReplyType["text"] = "text";
    AnswerReplyType["file"] = "file";
    AnswerReplyType["audio"] = "audio";
    AnswerReplyType["image"] = "image";
})(AnswerReplyType || (AnswerReplyType = {}));
